<template>
  <div id="app">
    <router-view />
    <loading></loading>
  </div>
</template>
<script>
import loading from '@/components/common/loading'
// import { config } from 'vue/types/umd'
// const webConfig = require('../static/config.json')
export default {
  name: 'App',
  components: {loading},
  methods: {
    // 判断移动端还是pc端
    _isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  mounted: function () {
    console.log(config.mobileUrl)
    if (this._isMobile()) {
      console.log('手机端')
      console.log(config.mobileUrl)
      window.location.href = config.mobileUrl
    } else {
      console.log('pc端')
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue